import AssistChip from 'components/Luxkit/Chips/AssistChip'
import DeprecatedDropdown from 'components/Luxkit/Dropdown/DeprecatedDropdown'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'
import CalendarDurationDropdown from './CalendarDurationDropdown'

const SizedDropdown = styled(DeprecatedDropdown)`
  border-radius: ${props => props.theme.borderRadius.M};
`

interface Props {
  duration: number;
  open?: boolean;
  rooms?: App.Occupants[];
  adultsNumber: number;
  showTaxExclusivePrices: boolean;
  displayPricingAsPerPerson: boolean;
  flights: boolean;
}

function CalendarDurationSelect(props: Props) {
  const { duration, open, rooms, adultsNumber, showTaxExclusivePrices, displayPricingAsPerPerson, flights } = props
  const dispatch = useOfferPageDispatch()
  const durationTriggerRef = useRef<HTMLButtonElement>(null)

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'duration' })
  }, [dispatch])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
  }, [dispatch])

  return (
    <>
      <AssistChip variant="outline" size="medium" ref={durationTriggerRef} onClick={onToggleOpen}>
        {pluralizeToString('night', duration)}
      </AssistChip>
      <SizedDropdown
        open={open}
        triggerRef={durationTriggerRef}
        onClose={onClose}
      >
        <CalendarDurationDropdown
          displayPricingAsPerPerson={displayPricingAsPerPerson}
          showTaxExclusivePrices={showTaxExclusivePrices}
          adultsNumber={adultsNumber}
          rooms={rooms}
          flights={flights}
          onClose={onClose}
        />
      </SizedDropdown>
    </>
  )
}

export default withOfferPageState((state) => ({
  duration: state.duration,
  open: state.activeSubFilter === 'duration',
}))(CalendarDurationSelect)
